// Moved to App/babel/components/ColorPicker (WEB-7832). This stub keeps intra-tree imports
// (e.g. admin/pages/editIntegration.jsx) working until Phase 6 deletes the Angular tree.
export { default } from 'App/babel/components/ColorPicker/ColorPicker';
